import React, { useMemo } from "react";
import { PictureListLayout } from "@companion-core/shared/app/Components/Blocks/Layouts/PictureListLayout";
import { BlockProps } from "@companion-core/shared/app/Interfaces/blocks";
import { ComponentData } from "@companion-core/shared/app/Interfaces/API";
import {
  getComponentButton,
  getComponentsCard,
  getComponentsFromBlockItems,
  getComponentText,
} from "@companion-core/shared/app/Utils/componentHelper";

export const PictureList = ({ simpleBlockItems, contentProps }: BlockProps) => {
  const simpleComponents: ComponentData[] = useMemo(
    () => getComponentsFromBlockItems(simpleBlockItems),
    [simpleBlockItems],
  );
  const title: string = useMemo(
    () => getComponentText(simpleComponents)?.title ?? "",
    [simpleComponents],
  );
  const subtitle: string = useMemo(
    () => getComponentText(simpleComponents)?.subtitle ?? "",
    [simpleComponents],
  );
  const cards: ComponentData[] = useMemo(
    () => getComponentsCard(simpleComponents),
    [simpleComponents],
  );
  const button: ComponentData | undefined = useMemo(
    () => getComponentButton(simpleComponents),
    [simpleComponents],
  );

  return (
    <PictureListLayout
      title={title}
      subtitle={subtitle}
      cards={cards}
      button={button}
      blockSlug={contentProps.slug}
    />
  );
};
